/* eslint-env node */
/**
 * National Recruitment display eligibility.
 *
 * Program Type config (enable_national_recruitment) AND a selected Topic
 * that is NOT on the Operations-maintained exclusion list.
 *
 * Exclusion list source: ref_config.NATIONAL_RECRUITMENT_EXCLUDED_TOPIC_IDS
 * (JSON array of topic IDs). Missing/empty config means no exclusions.
 *
 * Topic IDs are compared as strings so "12" and 12 are treated as the same ID.
 */

function parseExcludedTopicIds(rawConfig) {
    if (rawConfig == null || rawConfig === '') {
        return [];
    }

    let parsed = rawConfig;
    if (typeof rawConfig === 'string') {
        try {
            parsed = JSON.parse(rawConfig);
        } catch (err) {
            parsed = rawConfig.split(',').map(function (item) {
                return item.trim();
            }).filter(Boolean);
        }
    }

    if (!Array.isArray(parsed)) {
        return [];
    }

    return parsed.map(function (id) {
        return String(id);
    });
}

function hasTopic(topicId) {
    return topicId != null && String(topicId).trim() !== '';
}

/**
 * @param {object} params
 * @param {boolean} params.programTypeEnabled Project Program Type enable_national_recruitment
 * @param {*} params.topicId Selected speaker topic ID, or empty
 * @param {Array} params.excludedTopicIds Parsed exclusion list
 * @returns {boolean}
 */
function shouldShowNationalRecruitment(params) {
    const programTypeEnabled = params.programTypeEnabled == true;
    const topicId = params.topicId;
    const excludedTopicIds = Array.isArray(params.excludedTopicIds) ? params.excludedTopicIds : [];

    if (!programTypeEnabled) {
        return false;
    }

    if (!hasTopic(topicId)) {
        return false;
    }

    return excludedTopicIds.map(String).indexOf(String(topicId)) === -1;
}

module.exports = {
    parseExcludedTopicIds,
    shouldShowNationalRecruitment
};
